var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMandriva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2494_147620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 11,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91938 13.0754L10.4144 13.4912C10.4144 13.4912 8.35585 15.985 8.29665 16.0047C8.2374 16.0243 1.15232 16.0047 1.15232 16.0047V8.99853C1.15232 8.99853 0.261385 4.86204 1.15232 4.86204C2.0426 4.86204 4.73446 4.86204 4.73446 4.86204V5.83218V7.29644V10.6612V13.412L5.5059 14.2433L6.19911 14.3222L7.26755 14.1445L9.91938 13.0754Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2494_147620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.48438 6.49449C2.49368 7.61059 1.91965 8.94587 1.78519 10.4323C1.65381 11.8851 1.88711 13.7646 2.93343 14.8672C4.85995 16.8976 8.43974 14.6394 10.1284 13.4123C10.4634 13.169 10.6955 12.7851 11.0284 12.5433C9.24662 13.838 5.87331 15.9422 3.83335 13.9982C2.77645 12.9912 2.62221 11.1172 2.67292 9.75474C2.73033 8.21237 3.36718 6.77133 4.38436 5.62548C4.10892 5.9357 3.76076 6.18312 3.48438 6.49449Z",
    fill: "url(#paint0_linear_2494_147620)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0947 3.92322C12.0487 3.62689 11.8774 3.59086 11.7142 3.84323L9.77665 6.846C9.61388 7.09727 9.23837 7.26503 8.94208 7.21717L5.41383 6.64893C5.11684 6.60077 5.02979 6.75241 5.21966 6.98486L7.47637 9.756C7.66554 9.98905 7.70912 10.3971 7.57211 10.6647L5.94103 13.8446C5.80442 14.1123 5.92147 14.2415 6.2006 14.1333L9.53391 12.8429C9.81378 12.7351 10.2157 12.8201 10.4278 13.0322L12.9476 15.5666C13.1593 15.7801 13.3189 15.7094 13.3021 15.4096L13.1051 11.8405C13.0886 11.5415 13.2932 11.1851 13.5615 11.0496L16.751 9.43613C17.0188 9.30007 17.0003 9.12662 16.7097 9.04919L13.2554 8.13431C12.9651 8.05754 12.6902 7.75121 12.6441 7.45501L12.0947 3.92322Z",
    fill: "url(#paint1_linear_2494_147620)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0947 3.92322C12.0487 3.62689 11.8774 3.59086 11.7142 3.84323L9.77665 6.846C9.61388 7.09727 9.23837 7.26503 8.94208 7.21717L5.41383 6.64893C5.11684 6.60077 5.02979 6.75241 5.21966 6.98486L7.47637 9.756C7.66554 9.98905 7.70912 10.3971 7.57211 10.6647L5.94103 13.8446C5.80442 14.1123 5.92147 14.2415 6.2006 14.1333L9.53391 12.8429C9.81378 12.7351 10.2157 12.8201 10.4278 13.0322L12.9476 15.5666C13.1593 15.7801 13.3189 15.7094 13.3021 15.4096L13.1051 11.8405C13.0886 11.5415 13.2932 11.1851 13.5615 11.0496L16.751 9.43613C17.0188 9.30007 17.0003 9.12662 16.7097 9.04919L13.2554 8.13431C12.9651 8.05754 12.6902 7.75121 12.6441 7.45501L12.0947 3.92322Z",
    fill: "url(#paint2_linear_2494_147620)",
    stroke: "#FAB217",
    strokeWidth: 0.820778
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9374 7.89732L17.3198 9.03139Z",
    fill: "url(#paint3_linear_2494_147620)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9374 7.89732L17.3198 9.03139Z",
    fill: "url(#paint4_linear_2494_147620)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 7.89737C17.8158 7.90006 17.7461 7.90889 17.7091 7.97129C17.6691 8.03887 17.4836 8.38538 17.4836 8.38538C17.4836 8.38538 17.2932 8.72929 17.2582 8.79947C17.2259 8.86446 17.2561 8.92775 17.3199 9.03143C17.4414 9.02863 17.5112 9.01979 17.5481 8.95736C17.5881 8.88977 17.7735 8.54325 17.7735 8.54325C17.7735 8.54325 17.9639 8.19939 17.9991 8.12911C18.0314 8.06422 18.001 8.00093 17.9375 7.89737Z",
    fill: "url(#paint5_linear_2494_147620)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7566 9.20339L17.4409 9.21696Z",
    fill: "url(#paint6_linear_2494_147620)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7566 9.20339L17.4409 9.21696Z",
    fill: "url(#paint7_linear_2494_147620)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7566 9.20349C18.6938 9.09657 18.6513 9.03897 18.5774 9.03702C18.4974 9.03513 18.0971 9.04202 18.0971 9.04202C18.0971 9.04202 17.6965 9.04331 17.6165 9.04695C17.5428 9.05045 17.5015 9.1089 17.4409 9.21712C17.5037 9.32383 17.5461 9.38144 17.6201 9.38334C17.7001 9.38538 18.1004 9.37834 18.1004 9.37834C18.1004 9.37834 18.501 9.37709 18.581 9.3734C18.6547 9.37006 18.696 9.31151 18.7566 9.20349Z",
    fill: "url(#paint8_linear_2494_147620)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.041 10.5284L17.3418 9.40964Z",
    fill: "url(#paint9_linear_2494_147620)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.041 10.5284L17.3418 9.40964Z",
    fill: "url(#paint10_linear_2494_147620)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0411 10.5285C18.0999 10.4188 18.1268 10.3524 18.0899 10.2881C18.0498 10.2187 17.8346 9.87958 17.8346 9.87958C17.8346 9.87958 17.6241 9.53761 17.5793 9.47113C17.5378 9.40978 17.4662 9.40494 17.3419 9.40968C17.2833 9.51919 17.2563 9.58568 17.2933 9.64987C17.3333 9.71936 17.5486 10.0584 17.5486 10.0584C17.5486 10.0584 17.7591 10.4004 17.8039 10.467C17.8455 10.5282 17.917 10.5331 18.0411 10.5285Z",
    fill: "url(#paint11_linear_2494_147620)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5049 10.5492L17.1209 9.41607Z",
    fill: "url(#paint12_linear_2494_147620)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5049 10.5492L17.1209 9.41607Z",
    fill: "url(#paint13_linear_2494_147620)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5043 10.5492C16.6259 10.5464 16.6955 10.5375 16.7324 10.4752C16.7722 10.4076 16.9573 10.0614 16.9573 10.0614C16.9573 10.0614 17.1472 9.71777 17.1823 9.64763C17.2145 9.58274 17.1841 9.51955 17.1204 9.41602C16.9991 9.41887 16.9295 9.42775 16.8927 9.49005C16.8528 9.55763 16.6676 9.90384 16.6676 9.90384C16.6676 9.90384 16.4778 10.2475 16.4427 10.3177C16.4104 10.3825 16.4408 10.4458 16.5043 10.5492Z",
    fill: "url(#paint14_linear_2494_147620)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4004 7.91867L17.0997 9.03777Z",
    fill: "url(#paint15_linear_2494_147620)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4004 7.91867L17.0997 9.03777Z",
    fill: "url(#paint16_linear_2494_147620)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4007 7.91863C16.342 8.02824 16.3148 8.09467 16.3519 8.15896C16.392 8.2285 16.6072 8.56767 16.6072 8.56767C16.6072 8.56767 16.8176 8.90973 16.8625 8.97627C16.9041 9.03767 16.9757 9.04241 17.1 9.03772C17.1586 8.92816 17.1857 8.86171 17.1486 8.79748C17.1086 8.72799 16.8933 8.38883 16.8933 8.38883C16.8933 8.38883 16.6828 8.04665 16.638 7.98022C16.5964 7.91872 16.5248 7.91398 16.4007 7.91863Z",
    fill: "url(#paint17_linear_2494_147620)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2494_147620",
    x1: 6.08327,
    y1: 5.62548,
    x2: 6.08327,
    y2: 15.7401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2494_147620",
    x1: 6.44899,
    y1: 5.12819,
    x2: 14.8813,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2494_147620",
    x1: 6.44899,
    y1: 5.12819,
    x2: 14.8813,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2494_147620",
    x1: 6.44884,
    y1: 5.12819,
    x2: 14.8812,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2494_147620",
    x1: 6.44884,
    y1: 5.12819,
    x2: 14.8812,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2494_147620",
    x1: 6.44879,
    y1: 5.12819,
    x2: 14.8811,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2494_147620",
    x1: 6.44918,
    y1: 5.12815,
    x2: 14.8816,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2494_147620",
    x1: 6.44918,
    y1: 5.12815,
    x2: 14.8816,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2494_147620",
    x1: 6.44918,
    y1: 5.12819,
    x2: 14.8815,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2494_147620",
    x1: 6.44896,
    y1: 5.12819,
    x2: 14.8813,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2494_147620",
    x1: 6.44896,
    y1: 5.12819,
    x2: 14.8813,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2494_147620",
    x1: 6.44916,
    y1: 5.12818,
    x2: 14.8815,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2494_147620",
    x1: 6.44915,
    y1: 5.12819,
    x2: 14.8815,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2494_147620",
    x1: 6.44915,
    y1: 5.12819,
    x2: 14.8815,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2494_147620",
    x1: 6.44872,
    y1: 5.12819,
    x2: 14.8811,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2494_147620",
    x1: 6.4489,
    y1: 5.12818,
    x2: 14.8812,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2494_147620",
    x1: 6.4489,
    y1: 5.12818,
    x2: 14.8812,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2494_147620",
    x1: 6.44909,
    y1: 5.12819,
    x2: 14.8814,
    y2: 13.7443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524931,
    stopColor: "#F7A909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49109"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMandriva);
export default __webpack_public_path__ + "static/media/ic-mandriva.216629221f132713b88eef5cd9d43cfa.svg";
export { ForwardRef as ReactComponent };